/**
 * useBillingPortal — Layer 3 mutation. Opens the Stripe Billing Portal and
 * redirects to it. NO_SUBSCRIPTION (no Stripe customer) → friendly toast.
 */
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { createPortalSession } from "../api/billingApi";
import { toast } from "@/shared/lib/toast";
import { ErrorCode, getErrorCode } from "@/shared/lib/errorCodes";

export function useBillingPortal() {
  const { t } = useTranslation("pricing");
  return useMutation({
    mutationFn: createPortalSession,
    onSuccess: (url) => {
      window.location.assign(url);
    },
    onError: (err) => {
      toast.error(
        getErrorCode(err) === ErrorCode.NO_SUBSCRIPTION
          ? t("dashboard.errors.noSubscription")
          : t("dashboard.errors.portalGeneric"),
      );
    },
  });
}
